<!--
 * @Author: FengXiao
 * @Date: 2020-07-27 16:59:52
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-10 01:07:29
-->
<template>
  <div class="record-detail-page page-container">
    <video-player :datas="videoData" :speaker="speaker" :allowEvent.sync="playerAllowEvent" :viplock="vip_lock"
      :collect="miniTabActive[HEART_ID]" @clickCollect="onClickMiniTab(HEART_ID)"></video-player>
    <div class="content">
      <div class="container-wrap">
        <div class="left-bl clearfix">
          <transition name="el-fade-in-linear">
            <div class="child-bl" v-html="draft" v-show="miniTabActive[DOC_ID]"></div>
          </transition>
          <transition name="el-fade-in-linear">
            <comment-list class="child-bl" :topic="topic" type="record" :id="recordId" v-show="!miniTabActive[DOC_ID]"
              @inputFocus="inputFocus"></comment-list>
          </transition>
        </div>
        <div class="right-bl">
          <mini-tabs @onClickTab="onClickMiniTab" :active="miniTabActive"></mini-tabs>
          <recommend-videos :datas="recommendList" @click="onClickRecommend"></recommend-videos>
        </div>
      </div>
    </div>
    <buyvipDialog :payPopup="payPopup" v-show="payPopup" @close="close"></buyvipDialog>
    <buyvipResultDialog :payresPopup="payresPopup" v-show="payresPopup" :order_num="order_num"
      :order_status="order_status" :buy_type="buy_type" @closeres="closeres"></buyvipResultDialog>
  </div>
</template>

<script>
import VideoPlayer from '@/components/AppVideoPlayer';
import RecommendVideos from '@/components/AppRecommendVideos';
import MiniTabs from '@/components/AppMiniTabs';
import CommentList from '@/components/AppCommentList';
import requestApi from '@/service';
import buyvipDialog from '@/components/buy_vipDialog.vue';
import buyvipResultDialog from '@/components/buy_vipResultDialog.vue';
import { mapState } from 'vuex';

import configFields from '@/utils/configFields';
const { DOC_ID, HEART_ID, DRAFT_TYPE } = configFields;
export default {
  name: 'RecordDetail',
  components: {
    VideoPlayer,
    RecommendVideos,
    MiniTabs,
    CommentList,
    buyvipResultDialog,
    buyvipDialog,
  },
  data() {
    return {
      videoData: {},
      vip_lock: false,
      payPopup: false,
      playerAllowEvent: false, // 允许当前视频支持键盘事件
      speaker: {},
      recommendList: [],
      topic: {},
      comments: [
        {
          user: {
            avatar: 'https://cdn.yixi.tv/almond/15943931239036.jpg?imageView2/1/w/40/h/40',
            name: '玉小赤',
          },
          praise: '44',
          content: '"我们一直有一个信念，公益不是一两个人的倾家荡产，而是很多人的力所能及。“这句话好棒',
          date: '2020/07/10',
        },
        {
          user: {
            avatar: 'https://cdn.yixi.tv/almond/15943931239036.jpg?imageView2/1/w/40/h/40',
            name: '玉小赤',
          },
          praise: '44',
          content: '"我们一直有一个信念，公益不是一两个人的倾家荡产，而是很多人的力所能及。“这句话好棒',
          date: '2020/07/10',
        },
        {
          user: {
            avatar: 'https://cdn.yixi.tv/almond/15943931239036.jpg?imageView2/1/w/40/h/40',
            name: '玉小赤',
          },
          praise: '44',
          content: '"我们一直有一个信念，公益不是一两个人的倾家荡产，而是很多人的力所能及。“这句话好棒',
          date: '2020/07/10',
        },
        {
          user: {
            avatar: 'https://cdn.yixi.tv/almond/15943931239036.jpg?imageView2/1/w/40/h/40',
            name: '玉小赤',
          },
          praise: '44',
          content: '"我们一直有一个信念，公益不是一两个人的倾家荡产，而是很多人的力所能及。“这句话好棒',
          date: '2020/07/10',
        },
      ],
      commentsTotal: 2,
      DOC_ID,
      HEART_ID,
      miniTabActive: {},
      draft: '',
      recordId: null,
      payresPopup: false,
      order_num: '',
      buy_type: '',
      order_status: 1,//订单状态
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    $route(to) {
      if (to.path === '/record/detail') {
        this.init();
      }
    },
  },
  computed: {
    ...mapState(['vipInfo']),
  },
  beforeRouteEnter(to, from, next) {
    if ((from.path === '/' || !from.path) && to.query.id && to.query.order_num && to.query.buy_type) {
      window.$router.replace({
        name: 'SpeechDetail',
        query: { id: to.query.id },
        params: {
          id: to.query.id,
          order_num: to.query.order_num,
          buy_type: to.query.buy_type,
        },
      })
    } else {
      next(vm => {
        if (to.params.id && to.params.order_num && to.params.buy_type) {
          vm.check_order(to.params.order_num, to.params.buy_type);
        }
      })
    }
  },
  methods: {
    //判断时候支付成功
    check_order(ordernum, buytype) {
      this.order_num = ordernum
      this.buy_type = buytype
      console.log(this.order_num, this.buy_type)
      requestApi('/v3/api/h5/order/wanxiang/',
        {
          order_num: this.order_num,
          is_pc: 1,
          buy_type: this.buy_type,
        },
        'GET').then(res => {
          console.log(res)
          if (res.msg == '等待支付') {

          } else {
            this.order_num = ordernum
            this.buy_type = buytype
            this.order_status = 2
            this.payresPopup = true
          }
        });
    },
    closeres(val) {
      this.payresPopup = false
    },
    init() {
      Object.assign(this.$data, this.$options.data());
      this.recordId = this.$route.query.id;
      this.miniTabActive = {
        [DOC_ID]: false,
        [HEART_ID]: false,
      };
      this.getData();
      this.getRecommend();
      this.initScrollTop();
    },
    getData() {
      requestApi(`/v3/api/site/record/${this.recordId}/detail/`).then(({ record }) => {
        const { speaker, cover, video_url, title, city, date, titlelanguage, is_collect, member_type } = record;
        // 使用 map 方法替换 video_url 中的 http:// 为 https://
        const updatedVideoUrls = video_url.map(item => {
          if (item.video_url) {
            item.video_url = item.video_url.replace('http:', 'https:');
          }
          return item;
        });
        this.videoData = {
          cover,
          videoUrls: updatedVideoUrls,
          intro: titlelanguage,
        };
        this.miniTabActive[HEART_ID] = is_collect;
        this.speaker = speaker;
        this.topic = {
          title,
          city,
          date,
          intro: titlelanguage,
        };
        if (member_type == 2) {
          if (!this.vipInfo) {
            this.vip_lock = true
          }
        }
      });
    },
    getRecommend() {
      const url = `/v3/api/site/record/${this.recordId}/recommend/`;
      requestApi(url).then(({ recommended }) => {
        this.recommendList = recommended && recommended.length ? recommended : [];
      });
    },
    onClickMiniTab(id) {
      if (id === DOC_ID) {
        if (this.vip_lock) {
          if (this.checkLogin()) {
            return this.payPopup = true
          }
        }
        if (!this.draft) {
          this.getDarft().then(res => {
            if (res) {
              this.miniTabActive[id] = !this.miniTabActive[id];
            }
          });
        } else {
          this.miniTabActive[id] = !this.miniTabActive[id];
        }
      } else if (id === HEART_ID) {
        if (this.checkLogin()) {
          this.collect().then(() => {
            this.miniTabActive[id] = !this.miniTabActive[id];
          });
        }
      }
    },
    collect() {
      return requestApi(
        '/v3/api/v1/record/collection/change/',
        {
          record_id: this.recordId,
        },
        'POST'
      );
    },
    /**
     * @description: 获取演讲稿
     */
    getDarft() {
      return new Promise(resolve => {
        requestApi('/v3/api/site/draft/', {
          id: this.recordId,
          type: DRAFT_TYPE.record,
        }).then(({ draft }) => {
          if (draft) {
            this.draft = draft;
            resolve(true);
          } else {
            this.$message.error('未找到文稿');
            resolve(false);
          }
        });
      });
    },
    inputFocus(val) {
      if (val) {
        this.playerAllowEvent = false;
      }
    },
    onClickRecommend(id) {
      this.$router.push({
        path: '/record/detail',
        query: {
          id,
        },
      });
    },
    close(val) {
      this.payPopup = false
    },
  },
};
</script>

<style lang="scss" scoped>
.video-actions-bl {
  position: relative;
  width: 100%;
  text-align: center;
}

.content {
  .container-wrap {
    display: flex;
    align-items: flex-start;
    margin: 20px auto 100px;
  }

  .left-bl {
    width: 72%;
    max-width: 827px;
    margin-right: 10px;
    box-sizing: border-box;
    background: $C1;
    padding: 20px;
  }

  .right-bl {
    width: 28%;
    background-color: $C10;
  }
}
</style>
